// import React, { useEffect, useRef, createRef } from "react";
// import soilHealthImg from "../../../assets/styles/Soil_Health_Enhancers.png";
// import plantNutritionImg from "../../../assets/styles/Plant_Nutrition_Products.png";
// import cropProtectionImg from "../../../assets/styles/Crop_Protection_Solutions.png";
// import bioStimulantImg from "../../../assets/styles/Bio_Stimulants.png";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// const products = [
//   {
//     id: 1,
//     title: "Soil Health Enhancers",
//     img: soilHealthImg,
//     count: 237,
//   },
//   {
//     id: 2,
//     title: "Plant Nutrition Products",
//     img: plantNutritionImg,
//     count: 237,
//   },
//   {
//     id: 3,
//     title: "Crop Protection Solutions",
//     img: cropProtectionImg,
//     count: 237,
//   },
//   {
//     id: 4,
//     title: "Bio-Stimulants & Growth Aids",
//     img: bioStimulantImg,
//     count: 237, 
//   },
// ];

// const WhatWeOffer = () => {
//   const headingRef = useRef(null);
//   const descriptionRef = useRef(null);
//   const productRefs = useRef([]);
  
//   // Initialize refs array for products
//   productRefs.current = products.map((_, i) => productRefs.current[i] ?? createRef());
  
//   useEffect(() => {
//     // Register ScrollTrigger plugin
//     gsap.registerPlugin(ScrollTrigger);
    
//     // Create a timeline for sequential animations
//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: headingRef.current,
//         start: "top 80%",
//         end: "bottom 20%",
//         toggleActions: "play none none none"
//       }
//     });
    
//     // Set initial states
//     gsap.set([headingRef.current, descriptionRef.current], {
//       opacity: 0,
//       y: 20
//     });
    
//     // Animate heading
//     tl.to(headingRef.current, {
//       opacity: 1,
//       y: 0,
//       duration: 0.8,
//       ease: "power2.out"
//     });
    
//     // Animate description
//     tl.to(descriptionRef.current, {
//       opacity: 1,
//       y: 0,
//       duration: 0.8,
//       ease: "power2.out"
//     }, ">-0.4");
    
//     // Animate product cards with staggered effect
//     productRefs.current.forEach((ref, index) => {
//       gsap.set(ref.current, {
//         opacity: 0,
//         y: 30
//       });
      
//       tl.to(ref.current, {
//         opacity: 1,
//         y: 0,
//         duration: 0.8,
//         ease: "power2.out"
//       }, `>-${0.2 * index}`); // Stagger the animations
//     });
    
//     // Cleanup function
//     return () => {
//       ScrollTrigger.getAll().forEach(trigger => trigger.kill());
//     };
//   }, []);
  
//   return (
//     <section className="w-full max-w-[1280px] mx-auto px-4 md:px-4 py-12 py-[60px] md:py-[80px]">
//       {/* Heading */} 
//       <div className="flex flex-col md:flex-row justify-between items-center static text-center mb-8 gap-4 md:gap-[80px] lg:gap-[350px] px-[31px] md:px-0">
//         <h2 ref={headingRef} className="text-3xl md:text-[32px] lg:text-[44px] font-[LTWave] text-gray-900">
//           What We Offer
//         </h2>
//         <p ref={descriptionRef} className="text-[#6C6C6C] w-full md:max-w-[416px]  text-center md:text-left font-inter text-sm md:text-base lg:text-lg leading-[1.55]">
//           Science-backed, sustainable agri-inputs tailored to enhance soil, plant, 
//           and crop productivity.
//         </p>
//       </div>


//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-[20px]">
//         {products.map((product, index) => (
//           <div 
//             key={product.id} 
//             className="group"
//             ref={productRefs.current[index]}
//           >
//             {/* Image with rounded corners */}
//             <div className="relative overflow-hidden rounded-2xl">
//               <img
//                 src={product.img}
//                 alt={product.title}
//                 className="w-full h-[358px] md:h-[360px] object-cover transition-transform duration-300 group-hover:scale-105"
//               />
//               <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
//                 <h3 className="text-white text-center font-[LTWave] font-semibold">
//                   {product.title}
//                 </h3>
//               </div>
//             </div>

//             {/* Info below image */}
//             <div className="flex justify-between px-1 pt-[27px] md:py-[14px]">
//               <span className="text-sm font-medium text-[#1C1C1C]">
//                 0{product.id}
//               </span>
//               <span className="text-sm font-medium text-[#848484]">
//                 {product.count} Products
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Button */}
//       <div className="flex justify-center mt-10">
//       <button
//         className="px-6 py-3 rounded-full bg-[#EDEDED] font-inter text-base text-[#1C1C1C] font-regular 
//         flex items-center gap-2 
//         transition-all duration-300 ease-in-out
//         hover:bg-gray-300 hover:shadow-md hover:scale-105"
//       >
//         See all categories
//         <span className="text-lg transition-transform duration-300 ease-in-out group-hover:translate-x-1">
//         <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
//           <path d="M7.48926 14.0117L13.5133 7.98769" stroke="#1C1C1C" stroke-width="1.21704" stroke-linecap="round" stroke-linejoin="round"/>
//           <path d="M7.48926 7.9873H13.5133V14.0113" stroke="#1C1C1C" stroke-width="1.21704" stroke-linecap="round" stroke-linejoin="round"/>
//           </svg>
//           </span>
//         </button>
//       </div>
//     </section>
//   );
// };

// export default WhatWeOffer;

import React, { useEffect, useRef } from "react";
import soilHealthImg from "../../../assets/styles/Soil_Health_Enhancers.png";
import plantNutritionImg from "../../../assets/styles/Plant_Nutrition_Products.png";
import cropProtectionImg from "../../../assets/styles/Crop_Protection_Solutions.png";
import bioStimulantImg from "../../../assets/styles/Bio_Stimulants.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const products = [
  { id: 1, title: "Soil Health Enhancers", img: soilHealthImg, count: 237 },
  { id: 2, title: "Plant Nutrition Products", img: plantNutritionImg, count: 237 },
  { id: 3, title: "Crop Protection Solutions", img: cropProtectionImg, count: 237 },
  { id: 4, title: "Bio-Stimulants & Growth Aids", img: bioStimulantImg, count: 237 },
];

const WhatWeOffer = () => {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const descriptionRef = useRef(null);
  const productRefs = useRef([]);
  const buttonRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none none none", // ✅ no reverse
          once: true, // ✅ play only once
        },
      });

      tl.fromTo(
        [headingRef.current, descriptionRef.current],
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          stagger: 0.2,
        }
      );

      tl.fromTo(
        productRefs.current,
        { opacity: 0, y: 40, scale: 0.95 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: "power2.out",
          stagger: { amount: 0.4, from: "start" },
        },
        "-=0.3"
      );

      tl.fromTo(
        buttonRef.current,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
        },
        "-=0.2"
      );
    }, sectionRef);

    return () => {
      ctx.revert(); // ✅ safe cleanup
    };
  }, []);

  const setProductRef = (el, index) => {
    if (el) productRefs.current[index] = el;
  };

  
  return (
    <section 
      ref={sectionRef}
      className="w-full max-w-[1280px] mx-auto px-4 md:px-4 py-12 py-[60px] md:py-[80px]"
    >
      {/* Heading */} 
      <div className="flex flex-col md:flex-row justify-between items-center static text-center mb-8 gap-4 md:gap-[80px] lg:gap-[350px] px-[31px] md:px-0">
        <h2 ref={headingRef} className="text-3xl md:text-[32px] lg:text-[44px] font-[LTWave] text-gray-900">
          What We Offer
        </h2>
        <p ref={descriptionRef} className="text-[#6C6C6C] w-full md:max-w-[416px]  text-center md:text-left font-inter text-sm md:text-base lg:text-lg leading-[1.55]">
          Science-backed, sustainable agri-inputs tailored to enhance soil, plant, 
          and crop productivity.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-[20px]">
        {products.map((product, index) => (
          <div 
            key={product.id} 
            className="group"
            ref={(el) => setProductRef(el, index)}
          >
            {/* Image with rounded corners */}
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src={product.img}
                alt={product.title}
                className="w-full h-[358px] md:h-[360px] object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
                <h3 className="text-white text-center font-[LTWave] font-semibold">
                  {product.title}
                </h3>
              </div>
            </div>

            {/* Info below image */}
            <div className="flex justify-between px-1 pt-[27px] md:py-[14px]">
              <span className="text-sm font-medium text-[#1C1C1C]">
                0{product.id}
              </span>
              <span className="text-sm font-medium text-[#848484]">
                {product.count} Products
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Button */}
      <div ref={buttonRef} className="flex justify-center mt-10">
        <button
          className="px-6 py-3 rounded-full bg-[#EDEDED] font-inter text-base text-[#1C1C1C] font-regular 
          flex items-center gap-2 
          transition-all duration-300 ease-in-out
          hover:bg-gray-300 hover:shadow-md hover:scale-105"
        >
          See all categories
          <span className="text-lg transition-transform duration-300 ease-in-out group-hover:translate-x-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <path d="M7.48926 14.0117L13.5133 7.98769" stroke="#1C1C1C" strokeWidth="1.21704" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7.48926 7.9873H13.5133V14.0113" stroke="#1C1C1C" strokeWidth="1.21704" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </button>
      </div>
    </section>
  );
};

export default WhatWeOffer;